import { NamedIncident, PriorityType } from 'src/app/hickory-api';
import { Guid } from 'src/utility/guid';
import { DataGenerator } from './DataGenerator';

export class NamedIncidentData extends DataGenerator<NamedIncident> {
  static instance = new NamedIncidentData();
  protected createPredefined(): NamedIncident[] {
    return [
      {
        id: 'dd7e524aa90248c1b332097ca91c73c1',
        name: 'Attack of the Killer Bunnies',
        genericIncident: { id: '706a9f3a8edd4a6586018ac777e69e18' },
        priority: PriorityType.Emergency,
        associations: [
          { key: 'Asset.Area', values: [ 'North America', 'Europe' ]},
          { key: 'Asset.FacilityName', values: [ 'AlertSense' ]},
          { key: 'Asset.FacilityState', values: [
            'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU',
            'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN',
            'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK',
            'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA',
            'WV', 'WI', 'WY' ]}
        ]
      },
      {
        id: '927ef219599f4c42b08135e41b2f0493',
        name: 'Evil Midnight Bomber What Bombs At Midnight',
        genericIncident: { id: '56ba883fe4f14ba48b497f8869c57c49' },
        priority: PriorityType.Emergency
      },
      {
        id: 'ce910f3e404b4acfa9b5595e8b731a2f',
        name: 'Fire of the Ancients',
        genericIncident: { id: '7bd067dc62ea400b83b43e7145eca77b' },
        priority: PriorityType.Emergency
      },
      {
        id: '416c8da3850b4db8aba59a6f5d83403e',
        name: 'Breath of the Wild',
        genericIncident: { id: 'f85091479f96477ab6d7d15874348eb3' },
        priority: PriorityType.NonEmergency,
        associations: [
          { key: 'Asset.Id', values: [ '1e92a37e1e3a11e793ae92361f002671' ]}
        ]
      }
    ];
  }

  protected createGenerated(): NamedIncident[] {
    const list: NamedIncident[] = [];
    for (let i = 0; i < 100; i++) {
      if (i % 2 === 0) {
        list.push(this.generate(i));
      } else {
        list.push(this.generateAlternate(i));
      }
    }
    return list;
  }

  private generate(i: number): NamedIncident {
    return {
      id: Guid.newGuid(),
      name: i + ' Generated Named short',
      priority: PriorityType.Emergency
    };
  }

  private generateAlternate(i: number): NamedIncident {
    return {
      id: Guid.newGuid(),
      name: i + ' Generated Named with a long incident name',
      priority: PriorityType.NonEmergency
    };
  }

  add(incident: NamedIncident) {
    incident.id = Guid.newGuid();
    this._manual.push(incident);
  }

  delete(id: string) {
    this._manual = this._manual.filter(i => i.id !== id);
    this._predefined = this._predefined.filter(i => i.id !== id);
    this._generated = this._generated.filter(i => i.id !== id);
  }
}
export const namedIncidentData = NamedIncidentData.instance;
